import React from "react"
import { Link } from "gatsby"
import logo from '../../images/EE-logo.png'
import "./Footer.scss"
import "./KidsFooter.scss"
import KidsNeedHelp from "./KidsNeedHelp/KidsNeedHelp"

const KidsFooter = () => {
	const isPartiallyActive = ({ isPartiallyCurrent }) => {
		return isPartiallyCurrent ? { className: "active" } : {}
	}

	return (

		<footer className="site-footer">
			<div className="container">
				<div className="row">
					<div className="footer-wrapper">
						<div className="logo">
							<Link to={`/kids/`}
								data-analytics='{"event":"Navigation", "eventCategory":"Navigation", "eventAction":"Logo Click", "eventLabel":"Child Homepage"}' >
									{/*data-analytics='{"event":"Navigation", "eventCategory":"Navigation", "eventAction":"Logo Click", "eventLabel":"Child Homepage"}'*/}
									<img src={logo} alt="EE PhoneSmart" />
							</Link>
						</div>
						<div className="footer-links">
							<div className="footer-note-upper">Need any help? Something not working as expected? <KidsNeedHelp/> </div>
							<ul >
								<li>
									<a href={`/kids/cookie-kids/`} target={"_blank"} rel={"noreferrer"}
										data-analytics='{"event":"Navigation", "eventCategory":"Navigation", "eventAction":"Footer Link Click", "eventLabel":"Child Cookie policy"}'>
											Cookie policy
									</a>
								</li>
								<li>
									<a href={`/kids/terms-kids/`} target={"_blank"} rel={"noreferrer"}
										data-analytics='{"event":"Navigation", "eventCategory":"Navigation", "eventAction":"Footer Link Click", "eventLabel":"Child Terms and conditions"}'>
											Terms and conditions
									</a>
								</li>
								<li>
									<a href="https://ee.co.uk/eeprivacycentre" target="_blank" rel="noreferrer"
										data-analytics='{"event":"Navigation", "eventCategory":"Navigation", "eventAction":"Footer Link Click", "eventLabel":"https://ee.co.uk/eeprivacycentre"}'>
										Privacy policy
									</a>
								</li>
							</ul>
							<div className="footer-note-lower">We will keep track of your progress through the learning journey and share updates with your adult/guardian.</div>
						</div>
					</div>
					<div className="copyright">© 2021 EE Limited</div>
				</div>
			</div>

		</footer>
	)
}

export default KidsFooter
